import React from 'react';
import { FormBuilder } from 'commons-ui';
import useEdit from './useEdit';
import { LAUNCH_WIDGET_FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG, launchWidgetValidationSchema } from '../utils/formConfig';

const EditNotice: React.FC<{}> = () => {
	const { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useEdit();

	return (
		<FormBuilder
			data={data}
			mode='edit'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			validationSchema={launchWidgetValidationSchema}
			setShowLoader={setShowLoader}
			fieldConfig={LAUNCH_WIDGET_FORM_FIELD_CONFIG}
			layoutConfig={FORM_LAYOUT_CONFIG}
		/>
	);
};

export default EditNotice;
